import { mapGetters } from 'vuex';

// Define the countries to prioritize in list
const priorityCountries = [
  'United States of America',
  'Canada',
  'United Kingdom of Great Britain and Northern Ireland',
  'Australia',
  'Japan',
  'Germany',
  'Sweden',
  'France',
  'Republic of Korea',
  'Norway',
  'Netherlands',
  'Ireland',
  'South Africa',
  'Thailand',
  'Switzerland',
  'Spain',
  'Finland',
  'New Zealand',
  'China',
  'Taiwan',
  'Belgium',
  'Denmark',
  'Viet Nam',
  'Austria',
  'Italy',
  'Indonesia',
  'Iceland',
  'Mexico',
  'China, Hong Kong Special Administrative Region',
  'Poland',
  'Malaysia',
  'Singapore',
  'Philippines',
  'United Arab Emirates',
  'India',
];

export default {
  data() {
    return {
      countries: [],
    };
  },

  //* Call the countries endpoint when the component has been mounted
  mounted() {
    this.$store
      .dispatch('countries/all')
      // .dispatch('countries/listV3') //* v3 list
      // TODO v3 id = alpha2 and alpha_3 = alpha3
      .then((res) => {
        // console.log('res:', res);
        this.countries = this.countryList
          ?.map((x) => {
            return x;
          }, [])
          ?.sort((a, b) => {
            const aPriority = priorityCountries.indexOf(a?.name);
            const bPriority = priorityCountries.indexOf(b?.name);

            // Check if both countries are in the priority list
            if (aPriority !== -1 && bPriority !== -1) {
              // If both are in the priority list, sort them based on their index in the priority list
              return aPriority - bPriority;
            }
            if (aPriority !== -1) {
              // If only a is in the priority list, place it before b
              return -1;
            }
            if (bPriority !== -1) {
              // If only b is in the priority list, place it before a
              return 1;
            }
            // If neither is in the priority list, sort alphabetically
            return a?.name?.localeCompare(b?.name);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  },

  //* Fetch the countryList getter from the country module within Vuex
  computed: {
    ...mapGetters('countries', ['countryList']),
  },
};
